import type { TileLayerOptions } from 'leaflet'
import { getAccessToken } from '../../../shared/utils/auth/auth'
import type { ExtendedMapGroup, ExtendedMapGroupLegendItem } from '../../../shared/utils/map'
import MAP_CONFIG from '../legacy/services/map.config'

import type { Overlay } from '../../../shared/contexts/Layers/LayerProvider'

const findLayer = (layers: Array<ExtendedMapGroup | ExtendedMapGroupLegendItem>, id: string) => {
  return (layers.find((layer) => id === layer.id) as ExtendedMapGroup) ?? null
}

const generateOverlay = (layer: ExtendedMapGroup, token: string) => {
  if (layer.authScope && !token) {
    return null
  }

  const url = generateUrl(layer)

  if (!url) {
    return null
  }

  const params = layer.params ? Object.fromEntries(new URLSearchParams(layer.params)) : undefined

  const overlay: Overlay = {
    id: layer.id,
    type: layer.type,
    params,
    url,
    layer,
    options: {
      ...MAP_CONFIG.OVERLAY_OPTIONS,
      layers: layer.layers?.join(','),
    } as TileLayerOptions,
  }

  return overlay
}

function generateUrl(layer: ExtendedMapGroup) {
  if (!layer.url) {
    return null
  }

  return layer.external ? layer.url : `${MAP_CONFIG.OVERLAY_ROOT}${layer.url}`
}

export default function buildLeafletLayers(
  activeMapLayers: string[],
  mapLayers: Array<ExtendedMapGroup | ExtendedMapGroupLegendItem>,
) {
  return activeMapLayers
    .map((activeLegendId) => {
      const layer = findLayer(mapLayers, activeLegendId)

      if (!layer) {
        return null
      }

      return generateOverlay(layer, getAccessToken())
    })
    .filter((layer): layer is Overlay => !!layer)
}
